import React from 'react'
import { Link } from 'gatsby'
import { useLanguage } from '../../context/LanguageContext'
import { getHomePath } from '../../utils/paths'

const LANGUAGES = [
  { code: 'EL', label: 'GR' },
  { code: 'EN', label: 'EN' },
]

// Links to this page in the other language (`alternates` from the page context), or to that
// language's home page when the page has no translation.
const LanguageSwitcher = ({ alternates }) => {
  const { lang: currentLang, switchLanguage } = useLanguage()

  return (
    <div className="flex items-center gap-2 uppercase text-sm md:text-base">
      {LANGUAGES.map(({ code, label }, index) => (
        <React.Fragment key={code}>
          {code === currentLang ? (
            <span
              lang={code.toLowerCase()}
              className="hover:underline transition-all duration-300 underline text-brand font-bold"
            >
              {label}
            </span>
          ) : (
            <Link
              to={alternates?.[code] || getHomePath(code)}
              onClick={() => switchLanguage(code)}
              lang={code.toLowerCase()}
              hrefLang={code.toLowerCase()}
              className="hover:underline transition-all duration-300 text-gray-700"
            >
              {label}
            </Link>
          )}
          {index === 0 && <span className="mx-1">|</span>}
        </React.Fragment>
      ))}
    </div>
  )
}

export default LanguageSwitcher
